<!--
  ConversationsSkeleton — Phase 4-3 / T18.

  Five skeleton rows mirroring the real ConversationListItem layout. Pulse
  animation; respects prefers-reduced-motion.
-->
<script lang="ts">
  // Varied widths so the pattern doesn't look stamped.
  const rows: Array<{ line1: number; line2: number }> = [
    { line1: 70, line2: 90 },
    { line1: 55, line2: 70 },
    { line1: 80, line2: 60 },
    { line1: 45, line2: 85 },
    { line1: 65, line2: 75 },
  ];
</script>

<div class="skel" aria-hidden="true">
  {#each rows as r, i (i)}
    <div class="row">
      <div class="avatar pulse"></div>
      <div class="lines">
        <div class="line1 pulse" style="width: {r.line1}%;"></div>
        <div class="line2 pulse" style="width: {r.line2}%;"></div>
      </div>
      <div class="right">
        <div class="time pulse"></div>
        <div class="badge pulse"></div>
      </div>
    </div>
  {/each}
</div>

<style>
  .skel {
    display: flex;
    flex-direction: column;
    background: var(--widget-bg, oklch(99% 0.003 250));
  }
  .row {
    display: grid;
    grid-template-columns: 36px 1fr auto;
    column-gap: 12px;
    align-items: center;
    padding: 10px 14px;
    /* Must track ConversationListItem's locked height exactly. A skeleton
       that is the wrong height guarantees the reflow it exists to prevent. */
    box-sizing: border-box;
    height: 81px;
  }
  .avatar {
    width: 36px;
    height: 36px;
    border-radius: 50%;
  }
  .lines {
    display: flex;
    flex-direction: column;
    gap: 6px;
    min-width: 0;
  }
  .line1 {
    height: 11px;
    border-radius: 4px;
  }
  .line2 {
    height: 9px;
    border-radius: 4px;
  }
  .right {
    display: flex;
    flex-direction: column;
    align-items: flex-end;
    gap: 6px;
  }
  .time {
    width: 28px;
    height: 9px;
    border-radius: 4px;
  }
  .badge {
    width: 18px;
    height: 14px;
    border-radius: 999px;
  }

  .pulse {
    background: color-mix(in oklch, var(--widget-fg, oklch(20% 0.01 250)) 8%, transparent);
    animation: skel-pulse 1400ms ease-in-out infinite;
  }

  @keyframes skel-pulse {
    0%, 100% { opacity: 0.55; }
    50% { opacity: 0.85; }
  }

  @media (prefers-reduced-motion: reduce) {
    .pulse {
      animation: none;
      opacity: 0.7;
    }
  }
</style>
